/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Oauth_DropboxInputs */

const es_login_oauth_dropbox = /** @type {(inputs: Login_Oauth_DropboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox`)
};

const en_login_oauth_dropbox = /** @type {(inputs: Login_Oauth_DropboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox`)
};

/**
* | output |
* | --- |
* | "Dropbox" |
*
* @param {Login_Oauth_DropboxInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_oauth_dropbox = /** @type {((inputs?: Login_Oauth_DropboxInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Oauth_DropboxInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_oauth_dropbox(inputs)
	return en_login_oauth_dropbox(inputs)
});
export { login_oauth_dropbox as "login.oauth.dropbox" }